import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IParsedDataResponse } from '../../../../services/data/data-service.interface';

@Component({
  selector: 'gtd-tree-money-format',
  templateUrl: './tree-money-format.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TreeMoneyFormatComponent {
  @Input() format: IParsedDataResponse['treeMoneyFormat'];
  @Input() data: unknown;
}
